// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"f51dce22574d8fd5a7c0","678":"fb63cfbd6755b1a02280","713":"a10089f8db569faca2ef","883":"ef2f81a44b853e2713c3"}[chunkId] + ".js";
};